import PropTypes from 'prop-types';

export const Flags = PropTypes.shape({
  parentChild: PropTypes.bool,
  subjectLine: PropTypes.bool,
  demo: PropTypes.bool,
  ftpImport: PropTypes.bool,
  centerBlockInTable: PropTypes.bool,
  fallbackRules: PropTypes.bool,
  dontRelaxFatigue: PropTypes.bool,
  gdpr: PropTypes.bool,
  rightToLeft: PropTypes.bool,
  weather: PropTypes.bool
});

export const Selections = PropTypes.shape({
  data: PropTypes.shape({
    subscriber: PropTypes.string,
    selections: PropTypes.object
  }),
  isLoading: PropTypes.bool
});

export const Location = PropTypes.shape({
  City: PropTypes.string,
  Country: PropTypes.string,
  AdministrativeArea: PropTypes.string,
  Latitude: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  Longitude: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  Name: PropTypes.string,
  Region: PropTypes.string
});

export const Profile = PropTypes.shape({
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      tagType: PropTypes.string,
      tagValue: PropTypes.string
    })
  ),
  subscriberId: PropTypes.string,
  location: Location,
  locationLoading: PropTypes.bool
});
